import React, { useContext, useEffect, useState, useRef } from "react";
import { CRow, CContainer, CCol, CFormCheck } from "@coreui/react";
import Autocomplete from "react-google-autocomplete";
import Button from "src/components/atoms/Button/Button";
import styles from "./NewLocalTemplate.module.css";
import InfoTitle from "src/components/molecules/InfoTitle/InfoTitle";
import Input from "src/components/atoms/Input/Input";
import FileInput from "src/components/molecules/FileInput/FileInput";
import StatusSelect from "src/components/molecules/StatusSelect/StatusSelect";
import PickUpPointSwitch from "src/components/molecules/PickUpPointSwitch/PickUpPointSwitch";
import MultipartPhone from "src/components/molecules/MultipartPhone/MultipartPhone";
import SocialMediaInput from "src/components/molecules/SocialMediaInput/SocialMediaInput";
import TimeInputs from "src/components/molecules/TimeInputs/TimeInputs";
import { useLocation, useParams } from "react-router-dom";
import { DashboardContext } from "src/contexts/DashboardContext";
import Text from "src/components/atoms/Text/Text";
import Loader from "src/components/atoms/Loader/Loader";
import { v4 as uuidv4 } from 'uuid';
import companyBranchSchema from "./schemas/CompanyBranchSchema";
import moment from 'moment';


export default function NewLocalTemplate(props) {

  const user = JSON.parse(localStorage.getItem('user'));

  const {
    headData,
    formData,
    days,
    files,
    fileNames,
    handleDragDropEvent,
    setFiles,
    removeFile,
    inputRef,
    handleSubmit,
    gallery,
    navigate,
  } = props;

  let { id } = useParams();

  const {addLocalApiBody, setAddLocalApiBody, getCategoryServices, categoryServices, getBranch, addBranch, editBranch, loading, discountFields, setDiscountFields} = useContext(DashboardContext);

  const [servicesIds, setServicesIds] = useState([]);
  const [location, setLocation] = useState();
  const url = useLocation();
  const [pressed, setPressed] = useState(false)
  const [multipartFormData, setMultipartFormData] = useState(new FormData());
  const [formErrors, setFormErrors] = useState([])
  const isFormSubmitted = useRef(false);
 

  const handleInput = (e) => {
    setAddLocalApiBody({...addLocalApiBody, [e.target.id]: e.target.value});
  }
  const handleDiscountFields = (fieldId, e) => {
    const updatedFields = discountFields.map(field =>
      field.id === fieldId ? { ...field, [e.target.id]:e.target.value } : field
    );
    setDiscountFields(updatedFields);
  }
  const handleDeleteField = (id) => {
    setDiscountFields(discountFields.filter(field => field.id !== id));
  }
  const handleServices = (id) => {
    if(servicesIds?.includes(id)){
      const itemIndex = servicesIds?.indexOf(id);
      (itemIndex > -1) && servicesIds?.splice(itemIndex, 1)
      setServicesIds(servicesIds?.filter(serviceId => id !== serviceId))
    }else{
      servicesIds?.length ? setServicesIds([...servicesIds, id]) : setServicesIds([id]);
    }
  }

  const formatTimeSlots = (bodyTimeSlots) => {
    let timeSlots = []
    bodyTimeSlots?.forEach(slot => {
      timeSlots = [...timeSlots, {
        day: slot.day,
        from: moment(slot.from, "HH:mm:ss").format("HH:mm"),
        to: moment(slot.to, "HH:mm:ss").format("HH:mm")
      }]
    });

    return timeSlots;
  }

  const  formatData = (data) => {
    data.is_pick_up_point = data?.is_pick_up_point || false;
    data.time_slots = formatTimeSlots(data.time_slots);
    if(!data.phone_number || !data.phone_country_code || !data.phone_area_code){
      data.phone_number = null;
      data.phone_country_code = null;
      data.phone_area_code = null;
    }
    if(!data.whatsapp_number || !data.whatsapp_country_code || !data.whatsapp_area_code){
      data.whatsapp_number = null;
      data.whatsapp_country_code = null;
      data.whatsapp_area_code = null;
    }

    return data;
  }

  const validateForm = async (data) => {
    setFormErrors([]);
    try {
      let data = addLocalApiBody
      data = formatData(data)
      await companyBranchSchema.validate(data, { abortEarly: false });
      return true;
    } catch (err) {
      console.log(err)
      const errors = err.inner.reduce((acc, curr) => {
        acc[curr.path] = curr.message;
        return acc;
      }, {});
      setFormErrors(errors);
      return false;
    }
  }

  const handleSubmitForm = async (e) => {
    isFormSubmitted.current = true;
    const validated = await validateForm(addLocalApiBody);
    if(!validated) return;
    if(id){
      editBranch(id, addLocalApiBody, multipartFormData, navigate)
    }else{
      addBranch(addLocalApiBody, multipartFormData, navigate)
    }
  }

  useEffect(() => {
    if (isFormSubmitted.current) {
      console.log('isMounted');
      validateForm();
    } 
  }, [addLocalApiBody]);
  
  useEffect(() => {
    setAddLocalApiBody({...addLocalApiBody, services: servicesIds})
  },[servicesIds])

  useEffect(() => {
    if(id){
      getBranch(id);
      setServicesIds(addLocalApiBody?.services);
    }
  },[url.pathname])
  
  useEffect(() => {
    setAddLocalApiBody({})
  },[pressed]);

  useEffect(() => {
    getCategoryServices(user?.company?.company_category.id);
    window.onpopstate = e => {
      setPressed(true);
    };
  },[])

  useEffect(() => {
    files?.forEach(file => {
      multipartFormData.append('files[]', file);
    });
    for (let i = 0; i < gallery?.gallery.length; i++) {
      multipartFormData.append('gallery[]', gallery?.gallery[i]);
    }
  },[files])

  useEffect(() => {
    setAddLocalApiBody({
      ...addLocalApiBody,
      address:location?.formatted_address,
      lat: location?.geometry?.location.lat(),
      lng: location?.geometry?.location.lng()
    })
  },[location, id])


  useEffect(() => {
    setAddLocalApiBody({
      ...addLocalApiBody,
      benefits: discountFields?.map(discount => {
        if(discount.benefitId) {
          return {
            title:discount.title, 
            description:discount.description, 
            coupon: discount.code || null,
            id: discount.benefitId
          }
        }else{
          return {
            title:discount.title,
            description:discount.description, 
            coupon: discount.code || null,
          }
        }
      })
    })
  },[discountFields])
  


  return (
    loading ?
    <Loader/> :
    <CContainer>
      <CRow width="lg" className="mb-4">
        <CCol className={styles.headingContainer}>
          <Button
            inline
            text={id ? "Editar local" : "Agregar local"}
            icon={headData.img}
            reverse
            textSize="xxxl"
            textWeight="bold"
            textColor="black"
            textspacing="mediumSpacing"
            onClick={() => {
              navigate(-1);
              setAddLocalApiBody({});
            }}
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol className={styles.container}>
          <CRow>
            <CCol lg={6}>
              
              {/* Estado */}
              <CCol className={styles.infoContainer}>
                <InfoTitle
                  title={formData.status.title}
                  subTitle={formData.status.subTitle}
                />
                <div className={styles.selectContainer}>
                  <StatusSelect formData={formData} id={id}/>
                </div>
                <div class="mt-3">
                  {formErrors?.company_branch_status_id &&
                    <p className={styles.error}>{formErrors?.company_branch_status_id }</p>
                  }
                </div>
              </CCol>

              {/* Información del local */}
              <CCol className={styles.infoContainer}>
                <InfoTitle title={formData.localInfo.title} />
                <div className={styles.selectContainer}>
                  {formData.localInfo.form &&
                    formData.localInfo.form.map((item, i) => (
                      item.type == "multipartPhone" ?(
                        <>
                          <MultipartPhone 
                            item={item} 
                            inputClassName={`${styles.input} form-control`} 
                            selectClassName={`${styles.input} form-control`} 
                            rowClassName={styles.phoneRow}
                            data={addLocalApiBody} 
                            setData={setAddLocalApiBody}
                          /> 
                          
                        </>
                      )
                      : 
                      <div key={i}>
                        <Input 
                          item={item} 
                          key={i} 
                          onChange={(e) => handleInput(e)}
                        />
                        <div>
                          {(formErrors[item.id]) &&
                            <p className={styles.error}>{formErrors[item.id]}</p>
                          }
                        </div>
                      </div>
                    ))}
                    <Text size="sm">
                      Ubicación
                    </Text>
                    <Autocomplete
                      className={`${styles.input} form-control`}
                      apiKey="AIzaSyAbMcpxMPAhb4S_SvaeaupTOFAv4sWOJts"
                      onPlaceSelected={(place) => setLocation(place)}
                      defaultValue={addLocalApiBody?.address}
                      options={{
                        types: ["geocode", "establishment"],
                      }}
                    />
                    <div class="mt-3">
                      {((formErrors?.address) || (formErrors?.lat) || (formErrors?.lng)) &&
                        <p className={styles.error}>Dirección incorrecta</p>
                      }
                    </div>
                </div>
              </CCol>

              {/* ¿Qué ofrecés? */}
              <CCol className={styles.infoContainer}>
                <InfoTitle
                  title={formData.services.title}
                  subTitle={formData.services.subTitle}
                />
                {categoryServices &&
                  categoryServices?.map((item, i) => (
                    <div className={styles.checkboxContainer} key={i}>
                      <CFormCheck
                        label={item.name}
                        onChange={(e) => handleServices(e.target.id)}
                        id={item.id.toString()}
                        checked={addLocalApiBody.services?.includes(item.id.toString())}
                      />
                    </div>
                  ))}
                <div class="mt-3">
                  {formErrors?.services &&
                    <p className={styles.error}>{formErrors.services}</p>
                  }
                </div>
              </CCol>

              {/* Horarios */}
              <CCol className={styles.infoContainer}>
                <InfoTitle
                  title={formData.dates.title}
                  subTitle={formData.dates.subTitle}
                />
                <TimeInputs days={days} id={id} />
                 <div class="mt-3">
                  {formErrors?.time_slots &&
                    <p className={styles.error}>{formErrors?.time_slots }</p>
                  }
                </div>
              </CCol>

              {/* Galería */}
              <CCol className={styles.infoContainer}>
                <InfoTitle
                  title={formData.images.title}
                  subTitle={formData.images.subTitle}
                />
                <FileInput
                  id={id}
                  gallery={gallery.gallery}
                  setGallery={gallery.setGallery}
                  fileNames={fileNames}
                  files={files}
                  handleDragDropEvent={handleDragDropEvent}
                  setFiles={setFiles}
                  inputRef={inputRef}
                  removeFile={removeFile}
                />
              </CCol>

              {/* Discounts */}
              <CCol className={styles.infoContainer}>
                <InfoTitle 
                  title={formData.discounts.title} 
                  subTitle={formData.discounts.subTitle}
                />
                <div className={styles.selectContainer}>
                  {discountFields?.map((item, i) => (
                    <div className={styles.discountContainer}  key={item.id}>
                      <div className="d-flex justify-content-between align-items-center">
                        <Text size="md" weight="semiBold">
                          Promoción #{i+1}
                        </Text>
                        {i != 0 && 
                          <p 
                            className={styles.deleteButton}
                            onClick={() => handleDeleteField(item.id)}
                          >
                            Borrar
                          </p>
                        }
                      </div>
                      <Text size="md" weight="regular">
                        Título
                      </Text>
                      <input
                        id="title"
                        className="form-control"
                        value={item?.title}
                        onChange={(e) => handleDiscountFields(item.id, e)}
                      />
                      <div class="mt-3">
                        {formErrors[`benefits[${i}].title`] &&
                          <p className={styles.error}>{formErrors[`benefits[${i}].title`]}</p>
                        }
                      </div>
                      <Text size="md" weight="regular">
                        Descripción
                      </Text>
                      <input
                        id="description"
                        className="form-control"
                        value={item?.description}
                        onChange={(e) => handleDiscountFields(item.id, e)}
                      />
                       <div class="mt-3">
                        {formErrors[`benefits[${i}].description`] &&
                          <p className={styles.error}>{formErrors[`benefits[${i}].description`]}</p>
                        }
                      </div>
                      <Text size="md" weight="regular">
                        Cupón de descuento (opcional)
                      </Text>
                      <input
                        id="code"
                        type="text" 
                        value={item?.code}
                        className="form-control"
                        onChange={(e) => handleDiscountFields(item.id, e)}
                      />
                    </div>
                  ))}
                  <p 
                    className={styles.addButton}
                    onClick={() => setDiscountFields([
                      ...discountFields, 
                      {id:`field-${uuidv4()}`}
                    ])}
                  >
                    + Agregar otra promoción
                  </p>
                </div>
              </CCol>

              {/* RRSS */}
              <CCol className={styles.infoContainer}>
                <InfoTitle
                  title={formData.socialMedia.title}
                  subTitle={formData.socialMedia.subTitle}
                />
                <SocialMediaInput formData={formData} />
              </CCol>

              {/* Pick Up Point */}
              <CCol className={styles.infoContainer}>
                <InfoTitle
                  title={formData.pickUpPoint.title}
                  subTitle={formData.pickUpPoint.subTitle}
                />
                <div className={styles.selectContainer}>
                  <PickUpPointSwitch formData={formData} id={id}/>
                </div>
                <div class="mt-3">
                  {formErrors?.is_pick_up_point &&
                    <p className={styles.error}>{formErrors?.is_pick_up_point }</p>
                  }
                </div>
              </CCol>

              <CCol className={styles.buttonContainer} lg={4}>
                <Button
                  color={formData.button.color}
                  size={formData.button.size}
                  //disabled={disabledButton}
                  text={id ? "Editar local" : "Agregar local"}
                  onClick={handleSubmitForm}
                />
              </CCol>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CContainer>
  );
}
